import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "hide", "show", "focus" ]

  // Hide targets are initially Shown
  // Shown targets are initially hidden

  connect() {
    this.data.get('show-init') == "true" ? this.show() : this.hide()
  }

  clickShow(e) {
    e.preventDefault()
    e.stopPropagation()
    this.show()
  }

  clickHide(e) {
    e.preventDefault()
    e.stopPropagation()
    this.hide()
  }

  toggle() {
    this.shown ? this.hide() : this.show()
  }

  show() {
    this.shown = true
    this.showTargets.forEach(item => item.classList.remove('d-none'))
    this.hideTargets.forEach(item => item.classList.add('d-none'))
    if (this.data.has("grid")) {
      this.showTargets.forEach(item => item.classList.add('d-contents'))
      this.hideTargets.forEach(item => item.classList.remove('d-contents'))
    }
    this.hasFocusTarget && this.focusTarget.focus()
  }

  hide() {
    this.shown = false
    this.showTargets.forEach(item => item.classList.add('d-none'))
    this.hideTargets.forEach(item => item.classList.remove('d-none'))
    if (this.data.has("grid")) {
      this.showTargets.forEach(item => item.classList.remove('d-contents'))
      this.hideTargets.forEach(item => item.classList.add('d-contents'))
    }
  }
}
